// htmlToText-style text extraction strips <ul>/<ol>/<li> tags with no trace, so
// wrapping existing text in a list would otherwise compare as unchanged. Stamp a
// marker onto each <li> before tag-stripping so list structure survives normalization
// like any other meaningful text difference, while unlisted markup (b, span, div, etc.)
// still normalizes away as before.
//
// The marker holds the item's own list type and how deeply it is nested ("•ol2•"), so
// changing a bullet to a number or moving an item underneath another one counts too.
// Works on the HTML string rather than a DOM so the server can share it.
//
// The marker goes after any blanks or <p> the item starts with. Placed before them, it would be
// split from the text, so "<li><p>one" would not match "<li>one". A <br> there is dropped, as
// it would still become a line break between the marker and the text.
const LIST_TAG_PATTERN = /<(\/?)(ol|ul|li)\b[^>]*>((?:\s|&nbsp;|&#160;|&#xa0;|\u00a0|<p\b[^>]*>|<br\b[^>]*>)*)/gi
const LINE_BREAK_PATTERN = /<br\b[^>]*>/gi

/**
 * @param {string} html
 * @returns {string}
 */
export function markListStructure(html) {
    if (!html) return html

    const openLists = []

    return `${html}`.replace(LIST_TAG_PATTERN, markTag)

    function markTag(match, closing, tagName, leading) {
        const tag = tagName.toLowerCase()
        if (tag === "li") {
            if (closing) return match
            const listType = openLists[openLists.length - 1] ?? "ul"
            const openTag = match.slice(0, match.length - leading.length)
            return `${openTag}${leading.replace(LINE_BREAK_PATTERN, "")}•${listType}${openLists.length}•`
        }

        if (!closing) {
            openLists.push(tag)
        } else {
            const index = openLists.lastIndexOf(tag)
            if (index >= 0) openLists.length = index
        }
        return match
    }
}
